import React, { useEffect } from 'react';

interface JsonViewerModalProps {
  jsonString: string;
  onClose: () => void;
}

export const JsonViewerModal: React.FC<JsonViewerModalProps> = ({ jsonString, onClose }) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);

  let formattedJson: string;
  try {
    // Parse and re-stringify for pretty printing
    formattedJson = JSON.stringify(JSON.parse(jsonString), null, 2);
  } catch (error) {
    // If parsing fails, show the raw string
    formattedJson = 'Neplatný JSON formát:\n\n' + jsonString;
  }

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center" 
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="json-modal-title"
    >
      <div 
        className="bg-white rounded-lg shadow-xl p-6 m-4 max-w-2xl w-full max-h-[80vh] flex flex-col"
        onClick={e => e.stopPropagation()} // Prevent closing when clicking inside modal
      >
        <div className="flex justify-between items-center pb-3 border-b">
          <h2 id="json-modal-title" className="text-xl font-bold text-gray-800">Detailní JSON data</h2>
          <button 
            onClick={onClose} 
            className="text-gray-400 hover:text-gray-600 transition-colors"
            aria-label="Zavřít"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="overflow-y-auto mt-4">
          <pre className="bg-gray-100 p-4 rounded text-sm text-left whitespace-pre-wrap break-all">
            <code>
              {formattedJson}
            </code>
          </pre>
        </div>
      </div>
    </div>
  );
};